import { ILicense } from "Dashboard/domain/ILicense";
import { settingsService } from "Dashboard/services/settings.service";
import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectState } from "../outputSlice";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { FormatDate } from "utils/dateUtils";
import classes from "../../../../../../styles/g-grid-v2/components/print.module.scss";

interface IProps {
  doPrint: Function;
}

const PrintReport = ({ doPrint }: IProps) => {
  const memorandumLogo = useMemorandumLogo();

  const { outputReportForPrint } = useSelector(selectState);

  const [license, setLicense] = useState<ILicense>({
    companyName: "",
    address: "",
    contactPersonName: "",
    identificationNumber: "",
    landlinePhone: "",
    mobilePhone: "",
    taxId: "",
  });

  useEffect(() => {
    async function getData() {
      try {
        let license = await settingsService.getLicense();
        setLicense(license);
      } catch (e) { }
    }
    getData();

  }, []);

  useEffect(() => {
    doPrint(outputReportForPrint);
  }, [doPrint, outputReportForPrint]);

  return (
    <div className={classes.delNote}>
      <div className={`${classes.delNoteHeader} ${classes.delNoteReport}`}>
        <div className={classes.col1}>
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
          <div className={classes.companyInfo}>
            <span>{license.address}</span>
            <div>
              <span>Radni nalog br:</span>
              <span className={`${classes.space} ${classes.strong}`}>
                {outputReportForPrint?.workOrder}
              </span>
            </div>
            <div>
              <span>Magacin:</span>
              <span className={classes.space}>{outputReportForPrint?.repository.name}</span>
            </div>
            <div>
              <span>Datum:</span>
              <span className={classes.space}>
                {outputReportForPrint && FormatDate(outputReportForPrint.date)}
              </span>
            </div>
          </div>
        </div>
        <div className={classes.col2}>
        </div>
        <div className={classes.col3}>
          <div>
            <span>Naziv proizvoda:</span>
            <span className={`${classes.space} ${classes.strong}`}>
              {outputReportForPrint?.outputItem.name}
            </span>
          </div>
          <div>
            <span>Šifra proizvoda:</span>
            <span className={`${classes.space} ${classes.strong}`}>
              {outputReportForPrint?.outputItem.latestItemCode}
            </span>
          </div>
          <div>
            <span>Proizvedena količina:</span>
            <span className={`${classes.space} ${classes.strong}`}>
              {FormatNumberWithUnitOrNull(
                outputReportForPrint?.producedQuantity,
                outputReportForPrint?.outputItem.latestQuantityUnit?.name || ""
              )}
            </span>
          </div>
          <div>
            <span>Cena gotovog proizvoda:</span>
            <span className={`${classes.space} ${classes.strong}`}>
              {FormatNumberWithUnitOrNull(
                outputReportForPrint?.outputItem.latestPricePerUnit,
                "rsd"
              )}
            </span>
          </div>
        </div>
      </div>
      <div className={classes.delNoteMain}>
        <div className={`${classes.prtGrid} ${classes.prtGridReport}`}>
          <div className={`${classes.row} ${classes.headerX}`}>
            <div className={classes.col}>šifra artikla</div>
            <div className={`${classes.col} ${classes.left} ${classes.space}`}>
              naziv materijala
            </div>
            <div className={classes.col}>jed. mere</div>
            <div className={classes.col}>proizvedena količina</div>
            <div className={classes.col}>potreban materijal po jed. mere</div>
            <div className={classes.col}>ukupno</div>
          </div>
          {outputReportForPrint &&
            outputReportForPrint.inputItems.map((item, itemIndex) => (
              <>
                <div className={classes.row} key={item.inputItemId}>
                  <div className={`${classes.col} ${classes.strong} ${classes.bgWhite}`}>
                    {item.itemCode}
                  </div>
                  <div className={`${classes.col} ${classes.left} ${classes.bgWhite}`}>
                    {item.itemName}
                  </div>
                  <div className={classes.col}>{item.unit.name}</div>
                  <div className={`${classes.col} ${classes.bgWhite}`}>
                    {FormatNumber(
                      outputReportForPrint.producedQuantity,
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )}
                  </div>
                  <div className={`${classes.col} ${classes.bgWhite}`}>
                    {FormatNumber(
                      item.quantityPerProductUnit,
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )}
                  </div>
                  <div className={`${classes.col} ${classes.left} 
                        ${classes.strong} ${classes.bgWhite}`}>
                    {FormatNumber(
                      item.totalQuantity,
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )}
                  </div>
                </div>
                {item.bills.map((bill, billIndex) => (
                  <div className={`${classes.row} ${classes.billRow}`}>
                    <div className={`${classes.col} ${classes.right}`}>
                      {bill.billOfLandingId}
                    </div>
                    <div className={`${classes.col} ${classes.left}`}>
                      {FormatNumber(
                        bill.quantity,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </div>
                  </div>
                ))}
              </>
            ))}
        </div>

      </div>
      <div className={classes.delNoteFooter}>
        <div className={classes.col1}>
          <div className={classes.sigLine}>
            <span className={classes.label}>Sastavio</span>
            <span className={classes.line}></span>
          </div>
        </div>
        <div className={`${classes.col2} ${classes.hidden}`}>
          <div>
            <span>Prevoz:</span>
            <span>
            </span>
          </div>
        </div>
        <div className={classes.col3}>
          <div className={classes.sigLine}>
            <span className={classes.label}>Ovlašćeno lice</span>
            <span className={classes.line}></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintReport;
